import React from 'react'

function BusinessGoalTwo() {
    return (
        <div>
            {/* leading business solution area */}
            <div className="rts-business-solution rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6">
                            {/* business solution left */}
                            <div className="rts-business-solution-left">
                                <div className="thumbnail">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images_new/work_with_us.png`} alt="" />
                                </div>
                                <div className="success-rate">
                                    <h2 className="title">70+</h2>
                                    <span>Angajați activi</span>
                                </div>
                            </div>
                            {/* business solution left End */}
                        </div>
                        <div className="col-lg-6">
                            <div className="rts-business-solution-right">
                                <div className="title-area">
                                    <span className="sub">Hai în echipa IZODROM GRUP</span>
                                    <h2 className="title">
                                        Construim Moldova împreună<br />
                                        <span>
                                            Alătură-te <span>echipei noastre!</span>
                                        </span>
                                    </h2>
                                </div>
                                <div className="content-area">
                                    <p className="disc">
                                        De peste 20 de ani dezvoltăm proiecte de infrastructură inginerească la nivel național. Căutăm colegi pasionați, dornici să crească alături de profesioniști și să contribuie la modernizarea Moldovei. Vrei să faci parte dintr-o echipă unită și să lucrezi la proiecte de impact? Aplică acum!
                                    </p>
                                    {/* single business solution */}
                                    <div className="single-business-solution-2">
                                        <div className="icon">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images_new/01-work-icon.png`} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6 className="title">Mediu de lucru modern</h6>
                                            <p className="disc">
                                                Alătură-te unei echipe dinamice, cu proiecte diverse și oportunități reale de dezvoltare profesională.
                                            </p>
                                        </div>
                                    </div>
                                    {/* single business solution end */}
                                    {/* single business solution */}
                                    <div className="single-business-solution-2">
                                        <div className="icon">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images_new/02-work-icon.png`} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6 className="title">Proiecte de impact</h6>
                                            <p className="disc">
                                                Fii parte din transformarea infrastructurii Moldovei și lasă-ți amprenta în comunitate.
                                            </p>
                                        </div>
                                    </div>
                                    {/* single business solution end */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* leading business solution area End */}
        </div>
    )
}

export default BusinessGoalTwo